const $0e51f90751cab78f$var$flowbitePlugin = window.Flowbite.Plugin;
const $0e51f90751cab78f$var$config = {
    content: [
        "./index.html",
        "./node_modules/flowbite/**/*.js"
    ],
    plugins: [
        $0e51f90751cab78f$var$flowbitePlugin
    ]
};
var $0e51f90751cab78f$export$2e2bcd8739ae039 = $0e51f90751cab78f$var$config;


//# sourceMappingURL=index.eccd18de.js.map
